import { render, staticRenderFns } from "./block0.vue?vue&type=template&id=4705f83c&scoped=true&"
import script from "./block0.vue?vue&type=script&lang=js&"
export * from "./block0.vue?vue&type=script&lang=js&"
import style0 from "./block0.vue?vue&type=style&index=0&id=4705f83c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705f83c",
  null
  
)

export default component.exports